module.exports = __webpack_public_path__ + "static/img/book36.0867d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book36.jpg
// module id = hQHG
// module chunks = 1